import {setUses19Vat} from '@/redux-store/slices/auth';
import {store} from '@/redux-store/store';
import keycloakAxios from '@/services/axios';

export const getCompanyTax = async (companyEmail: string) => {
  const response = await keycloakAxios.post('payments/get-company-tax', {
    companyEmail
  });

  if (response.status >= 300) {
    throw new Error(
      `Error checking company tax: Invalid status code: ${response.status}`
    );
  }

  store.dispatch(setUses19Vat(response.data.use19Vat));

  return response.data;
};
